import React, { useState, useRef, useEffect } from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import ArrowButton from '../ArrowButton';
import AdMediaCounter from '../AdMediaCounter';
import * as Styles from './styles';
const notFoundURL = 'https://static.olx.com.br/cd/listing/notFound.png';
export const AdCardImageCarousel = _ref => {
  let {
    imageList = [],
    totalAdImages,
    totalAdVideos,
    badge,
    isSmallScreen,
    showDisabledButton,
    loading = 'lazy'
  } = _ref;
  const [currentImage, setCurrentImage] = useState(0);
  const currentImageRef = useRef(null);
  const nextImageRef = useRef(null);
  const container = useRef(null);
  const scrollable = useRef(null);
  !imageList.length && imageList.push({
    url: notFoundURL,
    alt: 'Anúncio sem imagens'
  });
  const isFirstImage = currentImage === 0;
  const isLastImage = currentImage === imageList.length - 1;
  const showLeftButton = !isFirstImage || showDisabledButton;
  const showRightButton = !isLastImage || showDisabledButton;
  const totalImages = isSmallScreen && totalAdVideos ? 0 : totalAdImages;
  const handleScroll = () => {
    var _a, _b;
    const amount = ((_a = container.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0;
    const scrollPos = ((_b = scrollable.current) === null || _b === void 0 ? void 0 : _b.scrollLeft) || 0;
    const scrollPhase = scrollPos / amount;
    if (Number.isInteger(scrollPhase)) {
      setCurrentImage(scrollPhase);
    }
  };
  const goPrev = () => {
    setCurrentImage(currentImage - 1);
  };
  const goNext = () => {
    setCurrentImage(currentImage + 1);
  };
  const doScroll = () => {
    var _a, _b;
    const amount = ((_a = container.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0;
    const multiplier = currentImage;
    (_b = scrollable.current) === null || _b === void 0 ? void 0 : _b.scrollTo({
      top: 0,
      left: amount * multiplier,
      behavior: 'smooth'
    });
  };
  const loadImage = imageRef => {
    const image = imageRef.current;
    if (image === null || image === void 0 ? void 0 : image.dataset.src) {
      image.src = image.dataset.src;
      image.dataset.src = '';
    }
  };
  useEffect(() => {
    loadImage(currentImageRef);
    loadImage(nextImageRef);
    doScroll();
  });
  const mapImages = (image, idx) => {
    let imageRef = null;
    if (idx === currentImage) {
      imageRef = currentImageRef;
    }
    if (idx === currentImage + 1) {
      imageRef = nextImageRef;
    }
    return React.createElement(Styles.ImageCarouselItem, {
      key: image.alt,
      isSmallScreen: isSmallScreen
    }, React.createElement("picture", null, React.createElement("source", {
      srcSet: image.urlWebP,
      type: "image/webp"
    }), React.createElement("source", {
      srcSet: image.url,
      type: "image/jpeg"
    }), React.createElement("img", {
      ref: imageRef,
      alt: image.alt,
      loading: loading,
      src: image.url
    })));
  };
  return React.createElement(Styles.AdCardImageCarouselWrapper, {
    ref: container,
    className: "adcard-carrousel",
    "data-ds-component": "DS-AdCardImageCarousel"
  }, React.createElement(Styles.ImageCarousel, {
    ref: scrollable,
    onScroll: handleScroll
  }, imageList.map(mapImages)), badge, !isSmallScreen && React.createElement(React.Fragment, null, showLeftButton && React.createElement(Styles.LeftButtonWrapper, null, React.createElement(ArrowButton, {
    onClick: goPrev,
    disabled: isFirstImage,
    "aria-label": "Imagem anterior"
  })), showRightButton && React.createElement(Styles.RightButtonWrapper, null, React.createElement(ArrowButton, {
    direction: "right",
    onClick: goNext,
    disabled: isLastImage,
    "aria-label": "Pr\u00F3xima imagem"
  }))), React.createElement(Styles.MediaCounterWrapper, null, React.createElement(AdMediaCounter, {
    imagesCount: totalImages,
    videosCount: totalAdVideos,
    hideNumbers: isSmallScreen
  })));
};
AdCardImageCarousel.displayName = 'AdCardImageCarousel';